import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

import AliceStore from 'bundles/alice/stores/AliceStore';
import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';
import routes from 'bundles/unified-google-certificates/routes';

import 'css!bundles/global-styles/global-element-styles';

const appEnv = new Fluxible({
  component: routes,
});

appEnv.registerStore(ApplicationStore);
appEnv.registerStore(NaptimeStore);
appEnv.registerStore(AliceStore);

export default appEnv;
